import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { emptyFn, isIE } from '../../utils/helper';
import Button from '../Button/index';
import Dragger from './Dragger';
import { decideKeepDom } from '../../utils/keepDom';
import { ContainerContext } from '../Snackbar/context';
import { consumeTheme } from '../../utils/theme';
import { PreventScrollPenetrateContainer, toggleGlobalScrollEvents } from '../../utils/preventScrollPenetrate';
import { WithStylusClick } from '../../utils/stylusAdapter';
import { restoreFocus, saveFocus, traverseFocusIn } from '../../utils/focus';
import { i18n } from '../../common/locale';
export var MODAL_TRANSITION_OUT_DURATION = 240;
var MODAL_TRANSITION_IN_DURATION = 300;
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.draggerRef = React.createRef();
        _this.footerRef = React.createRef();
        _this.isComposing = false;
        _this.handleClose = function (e) {
            var _a = _this.props, onClose = _a.onClose, onCancel = _a.onCancel, visible = _a.visible;
            if (!visible) {
                return;
            }
            var handler = onClose || onCancel;
            handler(e);
        };
        _this.handleMaskClick = function (e) {
            var _a = _this.props, maskClosable = _a.maskClosable, onClickMask = _a.onClickMask;
            if (maskClosable === true) {
                _this.handleClose(e);
            }
            onClickMask(e);
        };
        _this.handleDraggerClick = function (e) {
            e.stopPropagation();
        };
        _this.handleCompositionStart = function () {
            _this.isComposing = true;
        };
        _this.handleCompositionEnd = function () {
            _this.isComposing = false;
        };
        _this.handleKeyDown = function (e) {
            var _a;
            var _b = _this.props, visible = _b.visible, footer = _b.footer, okDisabled = _b.okDisabled;
            if (!visible || _this.isComposing) {
                return;
            }
            if (e.key === 'Tab') {
                _this.traverseFocus(e);
                return;
            }
            if (footer || footer === null) {
                return;
            }
            if (!okDisabled && e.key === 'Enter' && !((_a = _this.footerRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))) {
                _this.handleClickOk();
            }
            else if (e.key === 'Escape') {
                _this.handleClickCancel();
            }
        };
        _this.handleClickOk = function (e) {
            var _a = _this.props, visible = _a.visible, onOk = _a.onOk, okDisabled = _a.okDisabled;
            if (!visible || okDisabled) {
                return;
            }
            onOk(e);
        };
        _this.handleClickCancel = function (e) {
            var _a = _this.props, visible = _a.visible, onCancel = _a.onCancel;
            if (!visible) {
                return;
            }
            onCancel(e);
        };
        _this.handleClickAction = function (e) {
            var _a = _this.props, visible = _a.visible, onClickAction = _a.onClickAction;
            if (!visible) {
                return;
            }
            onClickAction(e);
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, title = _c.title, visible = _c.visible, maskStyle = _c.maskStyle, maskClassName = _c.maskClassName, mask = _c.mask, draggable = _c.draggable, onDragEnd = _c.onDragEnd, destroyOnClose = _c.destroyOnClose, zIndex = _c.zIndex, containerDom = _c.containerDom, header = _c.header, testId = _c.testId;
            var cls = classNames(prefixCls, className, prefixCls + "-" + (visible ? 'visible' : 'hidden'), (_a = {},
                _a[prefixCls + "-basic"] = _this.isBasic,
                _a));
            var maskCls = classNames(prefixCls + "-mask", maskClassName, prefixCls + "-mask-" + (visible ? 'visible' : 'hidden'), (_b = {},
                _b[prefixCls + "-mask-display"] = mask,
                _b[prefixCls + "-mask-in-container"] = containerDom !== document.body,
                _b));
            if (!containerDom || destroyOnClose && !decideKeepDom.call(_this, MODAL_TRANSITION_OUT_DURATION, visible)) {
                return null;
            }
            return ReactDOM.createPortal(h(ContainerContext.Provider, { value: _this.draggerDom },
                h(PreventScrollPenetrateContainer, { className: maskCls, style: __assign({ zIndex: zIndex }, maskStyle), onClick: _this.handleMaskClick, "aria-hidden": !visible },
                    h(Dragger, { className: cls, style: style, draggable: draggable, onDragEnd: onDragEnd, onClick: _this.handleDraggerClick, ref: _this.draggerRef, onKeyDown: _this.handleKeyDown, onCompositionStart: _this.handleCompositionStart, onCompositionEnd: _this.handleCompositionEnd, "data-testid": testId },
                        _this.renderClose(classNames),
                        header ? h("div", { className: classNames(prefixCls + "-header") }, header) : null,
                        title !== null ?
                            h("div", { className: classNames(prefixCls + "-title") }, title)
                            : null,
                        _this.renderContent(classNames),
                        _this.renderFooter(classNames)))), containerDom);
        };
        return _this;
    }
    Object.defineProperty(Modal.prototype, "draggerDom", {
        get: function () {
            var _a;
            return (_a = this.draggerRef.current) === null || _a === void 0 ? void 0 : _a.ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "isBasic", {
        get: function () {
            return this.props.type === 'basic';
        },
        enumerable: false,
        configurable: true
    });
    Modal.prototype.isFocusInside = function () {
        var _a;
        return (_a = this.draggerDom) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement);
    };
    Modal.prototype.focusSelf = function () {
        var _this = this;
        if (this.props.visible && !this.isFocusInside()) {
            saveFocus();
            setTimeout(function () {
                var _a;
                !_this.isFocusInside() && ((_a = _this.draggerDom) === null || _a === void 0 ? void 0 : _a.focus());
            }, MODAL_TRANSITION_IN_DURATION);
        }
    };
    Modal.prototype.restorePreviousFocus = function () {
        if (!this.props.visible) {
            restoreFocus();
        }
    };
    Modal.prototype.traverseFocus = function (e) {
        var container = this.draggerDom;
        if (!container) {
            return;
        }
        traverseFocusIn(container, e);
    };
    Modal.prototype.componentDidMount = function () {
        this.forceUpdate();
        this.focusSelf();
        var _a = this.props, visible = _a.visible, mask = _a.mask;
        toggleGlobalScrollEvents(Boolean(visible && mask));
    };
    Modal.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.visible) {
            this.focusSelf();
        }
        else {
            this.restorePreviousFocus();
        }
        var _a = this.props, visible = _a.visible, mask = _a.mask;
        toggleGlobalScrollEvents(Boolean(visible && mask));
    };
    Modal.prototype.componentWillUnmount = function () {
        toggleGlobalScrollEvents(false);
    };
    Modal.prototype.renderAction = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, action = _a.action;
        if (!action) {
            return null;
        }
        var actionMainNode;
        var icon;
        if (action !== null && typeof action === 'object') {
            if (React.isValidElement(action)) {
                actionMainNode = action;
            }
            else {
                if ('text' in action) {
                    actionMainNode = action.text;
                }
                if ('icon' in action) {
                    icon = action.icon;
                }
            }
        }
        else {
            actionMainNode = action;
        }
        return (h(WithStylusClick, { clickHandler: this.handleClickAction }, this.isBasic
            ? h(Button, { icon: icon }, actionMainNode)
            : h("button", { className: classNames(prefixCls + "-footer-action") },
                icon ?
                    typeof icon === 'string' ?
                        h("div", { className: classNames(prefixCls + "-footer-action-icon"), style: { backgroundImage: "url(\"" + icon + "\")" } })
                        : icon
                    : null,
                actionMainNode ?
                    typeof actionMainNode === 'string' ?
                        h("div", { className: classNames(prefixCls + "-footer-action-text") }, actionMainNode)
                        : actionMainNode
                    : null)));
    };
    Modal.prototype.renderFooter = function (classNames) {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, footer = _b.footer, okText = _b.okText, cancelText = _b.cancelText, okDisabled = _b.okDisabled, okButtonType = _b.okButtonType;
        if (footer === null) {
            return null;
        }
        else if (footer) {
            return footer;
        }
        var cancelElement = cancelText ?
            h(WithStylusClick, { clickHandler: this.handleClickCancel },
                h(Button, null, cancelText))
            : null;
        var okElement = (h(WithStylusClick, { clickHandler: this.handleClickOk },
            h(Button, { className: classNames(prefixCls + "-footer-ok"), type: okButtonType, disabled: okDisabled }, okText)));
        var actionElement = this.renderAction(classNames);
        var footerCls = classNames(prefixCls + "-footer", (_a = {},
            _a[prefixCls + "-footer-column"] = actionElement && this.isBasic,
            _a));
        return (h("div", { className: footerCls, ref: this.footerRef },
            cancelElement,
            actionElement,
            okElement));
    };
    Modal.prototype.renderContent = function (classNames) {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, title = _b.title, content = _b.content, children = _b.children;
        var contentCls = classNames(prefixCls + "-content", (_a = {},
            _a[prefixCls + "-content-empty-title"] = title === '',
            _a));
        var passedContent = content || children;
        var renderedContent = passedContent;
        if (isIE() && typeof passedContent === 'string') {
            renderedContent = h("span", { style: { maxWidth: '100%' } }, passedContent);
        }
        return isIE() ? (h("div", { style: { display: 'flex', flexDirection: 'column' } },
            h("div", { className: contentCls }, renderedContent))) : h("div", { className: contentCls }, renderedContent);
    };
    Modal.prototype.renderClose = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, closable = _a.closable, close = _a.close;
        if (!closable) {
            return null;
        }
        return (h(WithStylusClick, { clickHandler: this.handleClose }, close
            ? h("div", { className: classNames(prefixCls + "-close-container") }, close)
            : h("div", { className: classNames(prefixCls + "-close") })));
    };
    Modal.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Modal;
}(React.Component));
export default Modal;
Modal.defaultProps = {
    prefixCls: 'dui-modal',
    title: '',
    content: '',
    footer: '',
    onCancel: emptyFn,
    onOk: emptyFn,
    cancelText: i18n('cancel'),
    okText: i18n('ok'),
    mask: true,
    maskClosable: false,
    closable: true,
    onDragEnd: emptyFn,
    destroyOnClose: false,
    onClickMask: emptyFn,
    action: '',
    onClickAction: emptyFn,
    containerDom: typeof document !== 'undefined' ? document.body : undefined,
    okDisabled: false,
    type: 'editable',
    okButtonType: 'primary',
};
